import styles from './styles.module.css'
import { OperatoresCreationForm } from '../../widgets/operatores-creation-form'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { redirectIfNoRefreshToken } from '../../shared/redirects'
import { IconMenu } from '../../widgets/icon-menu'
import { RootState } from 'app/store'
import { useSelector } from 'react-redux'

export function OperatoresPage () {
    const roleOperator = useSelector((state: RootState) => state.loginSlice.role)
    const navigate = useNavigate()

    if (roleOperator !== 'administrator') {
        setTimeout(() => navigate('/'))
        return <></>
    }

    useEffect(() => {
        redirectIfNoRefreshToken(navigate)
    }, [])

    return <div className={styles.Page}>
        {/* <AdminMenu /> */}
        <div className={styles.ContentContainer}>
            <div className={styles.FormContainer}>
                <IconMenu
                    onSearchClick={() => { navigate('/operatores') }}
                    onDeleteClick={() => {}}
                />
                <OperatoresCreationForm />
            </div>
        </div>
    </div>
}
